import React, { useState } from "react";
import { FiCheckCircle, FiCircle, FiGlobe } from "react-icons/fi";
import SettingsHeader from "./SettingsHeader";

const GlobeIcon = FiGlobe;
const SelectedIcon = FiCheckCircle;
const EmptyIcon = FiCircle;

const languages = [
  { key: "nl", label: "Nederlands", subtitle: "Standaard" },
  { key: "en", label: "English", subtitle: "English" },
  { key: "fr", label: "Français", subtitle: "French" },
  { key: "de", label: "Deutsch", subtitle: "German" },
];

export default function LanguageSettingsScreen({ t, onBack }) {
  const [selected, setSelected] = useState("nl");

  return (
    <div className="pp-settings-screen pp-settings-subscreen pp-settings-language-screen">
      <SettingsHeader
        t={t}
        onBack={onBack}
      />

      <section className="pp-settings-card pp-settings-language-card">
        <div className="pp-settings-card-heading">
          <span className="pp-settings-card-icon" aria-hidden="true">
            <GlobeIcon />
          </span>
          <div>
            <h3>{t("parentPortal.settings.language", { defaultValue: "Language" })}</h3>
            <p>{t("parentPortal.settings.language_intro", { defaultValue: "Select the language used in the parent portal." })}</p>
          </div>
        </div>

        <div className="pp-settings-choice-list">
          {languages.map((language) => {
            const active = selected === language.key;
            const Icon = active ? SelectedIcon : EmptyIcon;
            return (
              <button
                type="button"
                key={language.key}
                className={`pp-settings-choice-row ${active ? "is-active" : ""}`}
                onClick={() => setSelected(language.key)}
              >
                <span className="pp-settings-choice-copy">
                  <span className="pp-settings-choice-title">{language.label}</span>
                  <span className="pp-settings-choice-subtitle">{language.subtitle}</span>
                </span>
                <Icon className="pp-settings-choice-icon" aria-hidden="true" />
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}
